import { useState } from 'react';
import AppIcon from '../../components/AppIcon';
import EmailMetricsCard from './components/EmailMetricsCard';
import EmailQueueList from './components/EmailQueueList';
import CampaignOverview from './components/CampaignOverview';
import DeliveryLogs from './components/DeliveryLogs';
import { formatNumber } from '../../utils/formatNumber';

const EmailAutomationDashboard = () => {
  const [dateFilter, setDateFilter] = useState('7days');
  const [statusFilter, setStatusFilter] = useState('all');
  const [showDemoNotification, setShowDemoNotification] = useState(true);

  const metrics = [
    {
      title: 'إجمالي الإيميلات المرسلة',
      value: formatNumber('12,458'),
      change: '+12.5%',
      changeType: 'increase',
      icon: 'Send',
      color: 'var(--color-primary)'
    },
    {
      title: 'معدل التسليم',
      value: '98.7%',
      change: '+2.1%',
      changeType: 'increase',
      icon: 'CheckCircle',
      color: 'var(--color-success)'
    },
    {
      title: 'معدل الفتح',
      value: '67.3%',
      change: '+5.8%',
      changeType: 'increase',
      icon: 'Eye',
      color: 'var(--color-accent)'
    },
    {
      title: 'معدل النقر',
      value: '24.6%',
      change: '-1.2%',
      changeType: 'decrease',
      icon: 'MousePointer',
      color: 'var(--color-secondary)'
    }
  ];

  const campaigns = [
    {
      id: 1,
      name: 'تأكيدات الحجز',
      type: 'booking',
      icon: 'CheckCircle',
      color: 'var(--color-success)',
      sent: 3245,
      delivered: 3198,
      opened: 2156,
      clicked: 892,
      status: 'active'
    },
    {
      id: 2,
      name: 'تنبيهات المصورين',
      type: 'photographer',
      icon: 'Camera',
      color: 'var(--color-secondary)',
      sent: 2187,
      delivered: 2165,
      opened: 1876,
      clicked: 654,
      status: 'active'
    },
    {
      id: 3,
      name: 'تذكيرات الدفع',
      type: 'payment',
      icon: 'DollarSign',
      color: 'var(--color-accent)',
      sent: 1543,
      delivered: 1521,
      opened: 1234,
      clicked: 876,
      status: 'active'
    },
    {
      id: 4,
      name: 'تحديثات الحساب',
      type: 'account',
      icon: 'User',
      color: 'var(--color-primary)',
      sent: 5483,
      delivered: 5401,
      opened: 3421,
      clicked: 1234,
      status: 'active'
    }
  ];

  const queueItems = [
    {
      id: 1,
      recipient: 'أحمد محمد العتيبي',
      email: 'ahmed@example.com',
      template: 'تأكيد حجز جديد - عميل',
      scheduledTime: '2026-01-11T20:00:00',
      status: 'pending',
      priority: 'high'
    },
    {
      id: 2,
      recipient: 'سارة عبدالله النمر',
      email: 'sara@example.com',
      template: 'تنبيه حجز جديد - مصور',
      scheduledTime: '2026-01-11T20:15:00',
      status: 'pending',
      priority: 'high'
    },
    {
      id: 3,
      recipient: 'خالد سعد الدوسري',
      email: 'khaled@example.com',
      template: 'تذكير دفع معلق',
      scheduledTime: '2026-01-12T10:00:00',
      status: 'scheduled',
      priority: 'medium'
    },
    {
      id: 4,
      recipient: 'نورة محمد القحطاني',
      email: 'noura@example.com',
      template: 'تذكير موعد الجلسة',
      scheduledTime: '2026-01-12T09:00:00',
      status: 'scheduled',
      priority: 'high'
    }
  ];

  const deliveryLogs = [
    {
      id: 1,
      recipient: 'فهد إبراهيم الشمري',
      email: 'fahad@example.com',
      template: 'تأكيد استلام الدفع',
      sentTime: '2026-01-11T18:45:00',
      status: 'delivered',
      openedAt: '2026-01-11T18:50:00',
      clickedAt: '2026-01-11T18:52:00'
    },
    {
      id: 2,
      recipient: 'ريم عبدالرحمن الحربي',
      email: 'reem@example.com',
      template: 'تحديث حالة الحجز',
      sentTime: '2026-01-11T18:30:00',
      status: 'delivered',
      openedAt: '2026-01-11T18:35:00',
      clickedAt: null
    },
    {
      id: 3,
      recipient: 'عبدالله محمد الزهراني',
      email: 'abdullah@example.com',
      template: 'تأكيد حجز جديد - عميل',
      sentTime: '2026-01-11T18:15:00',
      status: 'failed',
      error: 'عنوان البريد الإلكتروني غير صالح'
    },
    {
      id: 4,
      recipient: 'مها سعيد العمري',
      email: 'maha@example.com',
      template: 'تنبيه حجز جديد - مصور',
      sentTime: '2026-01-11T18:00:00',
      status: 'delivered',
      openedAt: '2026-01-11T18:05:00',
      clickedAt: '2026-01-11T18:07:00'
    }
  ];

  const dateFilterOptions = [
    { value: '24hours', label: 'آخر 24 ساعة' },
    { value: '7days', label: 'آخر 7 أيام' },
    { value: '30days', label: 'آخر 30 يوم' },
    { value: '90days', label: 'آخر 90 يوم' }
  ];

  const handleSimulateQueue = () => {
    alert('✅ تم محاكاة معالجة قائمة الانتظار!\n\nتم معالجة 4 إيميلات في الوضع التجريبي.\nجميع الإيميلات تم "إرسالها" بنجاح.');
  };

  return (
    <div className="min-h-screen bg-background py-8 px-4 sm:px-6 lg:px-8" dir="rtl">
      <div className="max-w-7xl mx-auto">
        {/* Demo Mode Notification */}
        {showDemoNotification && (
          <div className="mb-6 bg-amber-50 border border-amber-200 rounded-lg p-4">
            <div className="flex items-start justify-between gap-4">
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 rounded-full bg-amber-100 flex items-center justify-center flex-shrink-0">
                  <AppIcon name="AlertCircle" size={20} className="text-amber-600" />
                </div>
                <div>
                  <h3 className="text-sm font-semibold text-amber-900 mb-1">الوضع التجريبي مفعّل</h3>
                  <p className="text-sm text-amber-700 leading-relaxed">
                    جميع البيانات والإحصائيات المعروضة هي بيانات تجريبية. لا يتم إرسال إيميلات فعلية في هذا الوضع.
                  </p>
                </div>
              </div>
              <button
                onClick={() => setShowDemoNotification(false)}
                className="text-amber-600 hover:text-amber-800 transition-colors"
              >
                <AppIcon name="X" size={18} />
              </button>
            </div>
          </div>
        )}

        {/* Header */}
        <div className="mb-8">
          <div className="flex items-center justify-between mb-2">
            <div>
              <h1 className="text-3xl font-bold text-foreground mb-2">لوحة تحكم الإيميلات التلقائية</h1>
              <p className="text-muted-foreground">مراقبة وإدارة حملات الإيميل التلقائية</p>
            </div>
            <div className="flex gap-3">
              <button 
                onClick={handleSimulateQueue}
                className="flex items-center gap-2 px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors"
              >
                <AppIcon name="Play" size={18} />
                <span className="text-sm font-medium">معالجة قائمة الانتظار (تجريبي)</span>
              </button>
              <button className="flex items-center gap-2 px-4 py-2 bg-muted text-foreground rounded-lg hover:bg-muted/80 transition-colors">
                <AppIcon name="Settings" size={18} />
                <span className="text-sm font-medium">إعدادات التشغيل</span>
              </button>
            </div>
          </div>
        </div>

        {/* Date Filter */}
        <div className="mb-6 flex items-center gap-4">
          <span className="text-sm font-medium text-foreground">الفترة الزمنية:</span>
          <div className="flex gap-2">
            {dateFilterOptions?.map(option => (
              <button
                key={option?.value}
                onClick={() => setDateFilter(option?.value)}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                  dateFilter === option?.value
                    ? 'bg-primary text-primary-foreground'
                    : 'bg-muted text-muted-foreground hover:bg-muted/80'
                }`}
              >
                {option?.label}
              </button>
            ))}
          </div>
        </div>

        {/* Metrics Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
          {metrics?.map((metric, index) => (
            <EmailMetricsCard key={index} metric={metric} />
          ))}
        </div>

        {/* Campaign Overview */}
        <div className="mb-8">
          <CampaignOverview campaigns={campaigns} />
        </div>

        {/* Email Queue and Delivery Logs */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <EmailQueueList queueItems={queueItems} />
          <DeliveryLogs logs={deliveryLogs} statusFilter={statusFilter} setStatusFilter={setStatusFilter} />
        </div>
      </div>
    </div>
  );
};

export default EmailAutomationDashboard;